import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { cpp } from '@codemirror/lang-cpp';
import { oneDark } from '@codemirror/theme-one-dark';
import { EditorView } from '@codemirror/view';
import { useTheme } from '../../contexts/ThemeContext';

// Light theme for CodeMirror
const lightTheme = EditorView.theme({
    '&': { backgroundColor: '#f8f9fa' },
    '.cm-gutters': { backgroundColor: '#f0f0f0', borderRight: '1px solid #ddd' },
    '.cm-content': { caretColor: '#333' },
    '.cm-line': { color: '#333' },
});

interface ContextCodeProps {
    code: string;
    label?: string;
}

// Bloc de code de contexte partagé par tous les types de questions :
// rendu CodeMirror en lecture seule, cohérent light/dark.
export const ContextCode: React.FC<ContextCodeProps> = ({ code, label = 'Code de référence' }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <div>
            <div className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-2">
                {label}
            </div>
            <div className="rounded-lg overflow-hidden border border-gray-300 dark:border-gray-700">
                <CodeMirror
                    value={code}
                    theme={isDark ? oneDark : lightTheme}
                    extensions={[cpp()]}
                    height="auto"
                    editable={false}
                    basicSetup={{
                        lineNumbers: true,
                        foldGutter: false,
                    }}
                />
            </div>
        </div>
    );
};

export default ContextCode;
